import { errorService } from '../services/ErrorService';

/**
 * Exibe um toast de erro com mensagem amigável
 * @param {Object} toast - Referência do componente Toast do PrimeReact
 * @param {string} summary - Título do toast
 * @param {Error} error - Objeto de erro
 */
export const showErrorToast = (toast, summary, error) => {
    toast.current.show({
        severity: 'error',
        summary: summary,
        detail: errorService.getFriendlyMessage(error),
        life: 3000
    });
};

/**
 * Exibe um toast de sucesso
 * @param {Object} toast - Referência do componente Toast do PrimeReact
 * @param {string} summary - Título do toast
 * @param {string} detail - Mensagem detalhada
 */
export const showSuccessToast = (toast, summary, detail) => {
    toast.current.show({
        severity: 'success',
        summary: summary,
        detail: detail,
        life: 3000
    });
}; 